import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';
import { EIntegrationTargetType } from '../enum/integration-target-type.enum';

export class TargetType extends PrimitiveValueObject<EIntegrationTargetType> {
  static create(value: EIntegrationTargetType): TargetType {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new TargetType(value);
  }
}
